"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var index_1 = __importStar(require("../Colors/index"));

var index_2 = __importDefault(require("../Icon/index")); // tslint:disable-next-line:variable-name


var Badge = function Badge(props) {
  var icon = props.icon,
      color = props.color,
      children = props.children,
      className = props.className;
  var cn = classnames_1.default('emankit__badge', index_1.default(color || index_1.BaseColor.LightBlue), {
    with_icon: icon != null
  }, className);
  var iconItem = null;

  if (icon != null) {
    iconItem = react_1.default.createElement(index_2.default, {
      icon: icon
    });
  }

  return react_1.default.createElement("div", {
    className: cn
  }, iconItem, react_1.default.createElement("span", null, children));
};

exports.default = Badge;